import { render, staticRenderFns } from "./AscentGymRouteIcon.vue?vue&type=template&id=05a57c0a"
import script from "./AscentGymRouteIcon.vue?vue&type=script&lang=js"
export * from "./AscentGymRouteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports